import { useEffect } from "react";
import { DisplayInformations } from "../../../../elements/list/popup";
import withLayout from "../../../common/layout";
import { getData, putData } from "../../../../../backend/api";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NoData } from "../../../../elements/list/styles";
import { RowContainer } from "../../../../styles/containers/styles";
import ViewFiles from "../../documents/ViewFiles";
import { useNavigate } from "react-router-dom";
import CrudForm from "../../../../elements/list/create";
import { useDispatch } from "react-redux";

const Profile = ({ itemTitle = `firstName`, profileImage = "photo", formMode = "double", formView = "tab", openData, setMessage, setLoaderBox }) => {
  const [user, setUser] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation();
  useEffect(() => {
    getData({}, "user/me", dispatch, navigate).then((response) => {
      setUser(response.data);
    });
  }, []);

  useEffect(() => {
      document.title = `${t("profile")} - Whistleblowing24`;
    }, [t]);

  const [attributes] = useState([
    // {
    //   type: "text",
    //   placeholder: "fullName",
    //   name: "fullName",
    //   tab: "generalInfo",
    //   validation: "textonly",
    //   default: "",
    //   label: "fullName",
    //   required: true,
    //   view: true,
    //   add: false,
    //   update: false,
    // },
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "academicTitle",
      name: "academicTitle",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "title",
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: true,
      update: true,
      apiType: "CSV",
      selectApi: "Prof.,Dr.",
    },
    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      tab: "generalInfo",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "email",
      tab: "generalInfo",
      name: "email",
      validation: "email",
      default: "",
      label: "email",
      required: false,
      view: true,
      tag: true,
      add: true,
      update: true,
    },
  ]);
  const [viewFile, setViewFile] = useState(false);
  const [data, setData] = useState({});

  const [updateAttributes] = useState([
    {
      type: "text",
      placeholder: "firstName",
      name: "firstName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "firstName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "lastName",
      name: "lastName",
      tab: "generalInfo",
      validation: "textonly",
      default: "",
      label: "lastName",
      required: true,
      view: false,
      add: true,
      update: true,
    },
    {
      type: "select",
      placeholder: "academicTitle",
      name: "academicTitle",
      tab: "generalInfo",
      validation: "",
      default: "",
      label: "title",
      required: false,
      view: false,
      filter: false,
      tag: true,
      add: true,
      update: true,
      apiType: "CSV",
      selectApi: "Prof.,Dr.",
    },
    {
      type: "text",
      placeholder: "mobileNumber",
      name: "mobileNumber",
      tab: "generalInfo",
      validation: "mobile",
      default: "",
      label: "mobileNumber",
      required: false,
      view: true,
      add: true,
      update: true,
    },
  ])

  const [updateId, setUpdateId] = useState("");
  const [updateValues, setUpdateValues] = useState({});
  const [udpateView, setUpdateView] = useState(() => {});
  const [isEditing, setIsEditing] = useState(false);
  const isEditingHandler = (value, callback) => {
    setLoaderBox(true);
    if (!isEditing) {
      setUpdateView(() => callback);
      const updateValues = {};
      setUpdateId(value?._id);
      updateAttributes.forEach((item) => {
        if (item.update) {
          if (item.type === "checkbox") {
            let bool = value[item.name] ? (value[item.name].toString() === "true" ? true : false) : false;
            updateValues[item.name] = bool;
          } else if (item.type === "number") {
            let bool = parseInt(value[item.name]);
            updateValues[item.name] = bool;
          } else if (item.type === "select") {
            updateValues[item.name] = typeof value[item.name] === "undefined" ? "" : typeof value[item.name] === "string" || typeof value[item.name] === "number" ? value[item.name] : value[item.name]?._id ? value[item.name]._id : "";
          } else if (item.type === "multiSelect") {
            updateValues[item.name] = Array.isArray(value[item.name]) ? value[item.name] : [];
          } else if (item.type === "image") {
            updateValues["selected_" + item.name] = [];
            updateValues[item.name] = value[item.name] ? value[item.name] : "";
          } else {
            updateValues[item.name] = (value && value[item.name]) ? value[item.name] : "";
          }
        }
      });
      setUpdateValues(updateValues);
      setIsEditing(true);
      window.location.hash = "edit";
    } else {
      setUpdateId("");
      navigate({}, "", window.location.pathname);
      setIsEditing(false);
    }
    setLoaderBox(false);
  };
  
  const updateHandler = async (data) => {
    setLoaderBox(true);
    await putData(data, `user/employeeUpdate/${updateId}`, dispatch, navigate)
      .then((response) => {
        if (response.status === 200) {
          setMessage({ type: 1, content: t("updated", { shortName: t("profile") }), proceed: "Okay", code: 200 });
          setUser(response.data.item)
          setIsEditing(false);
        } else if (response.status === 404) {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 404 });
        } else {
          setMessage({ type: 1, content: t(response.data), proceed: "Okay", code: 500 });
        }
        setLoaderBox(false);
      })
      .catch((error) => {
        alert(error);
        setLoaderBox(false);
      });
  };

  return user ? (
    <>
      <DisplayInformations isEditingHandler={isEditingHandler} actions={null} customClass="profile" key={"profile"} setMessage={setMessage} setLoaderBox={setLoaderBox} profileImage={profileImage} formMode={formMode} formView={"tabs"} attributes={attributes} data={user} viewDetails={false} />
      {viewFile && <ViewFiles customClass="large" page={data} onClose={() => setViewFile(false)} setLoaderBox={setLoaderBox} title={"attendanceToday"}></ViewFiles>}
      {isEditing && <CrudForm setMessage={setMessage} formMode={formMode} formView={"normal"} api={"api"} formType={"put"} updateId={updateId} header={t("update", { label: t("profile") })} formInput={updateAttributes} formErrors={false} formValues={updateValues} submitHandler={updateHandler} isOpenHandler={isEditingHandler} isOpen={isEditing} actions={null} setLoaderBox={setLoaderBox} openData={openData} ></CrudForm>}
    </>
  ) : (
    <RowContainer>
      <NoData>Loging Profile</NoData>
    </RowContainer>
  );
};
export default withLayout(Profile);
